/*
* Bid letter contract pages
*/

import * as _ from 'lodash';
import * as React from 'react';
import stringtemplate from 'string-template';

import { Formatters } from '../../../common/formatters';
import * as OrderCommon from '../../order-common';
import * as BidLetterReportComponents from '../report-components';

export const Render = ({ reportData, ...rest }) => {
    const { currentOrder, branding, association, associationClient, orderClient, pricingMatrix, serviceLevels, orderManagerUser, bidLetterTextContents, twoOptionPricing, ...otherReportData } = reportData;

    const orderClientStateCode = Formatters.getStr(currentOrder, 'association.client.location.stateCode');

    let bidLetterContractData = {
        ASSOCIATION_CLIENT_LOCATION_STATE_NAME: OrderCommon.BidLetterStateNameFromStateCode(orderClientStateCode),

        ASSOCIATION_ID: Formatters.getStr(currentOrder, 'associationId'),
        ASSOCIATION_NAME: Formatters.getStr(association, 'name'),
        ORDER_ASSOCIATION_NAME: Formatters.getStr(currentOrder, 'association.name'),
        CHOSEN_REPORT_LEVEL: (twoOptionPricing) ? (Formatters.getStr(currentOrder, 'serviceLevel.report', `Full / Financial Update (Circle One)`)) : Formatters.getStr(currentOrder, 'serviceLevel.report', '_____'),
        CHOSEN_REPORT_TURNAROUND_WEEKS: Formatters.getStr(currentOrder, 'serviceLevel.timeframe', '____'),
        CHOSEN_REPORT_TOTAL_FEE: (Formatters.getFloat(currentOrder, 'acceptedPrice') > 0) ? '$' + Formatters.getFloat(currentOrder, 'acceptedPrice') : '____________',

        COMPANY_NAME: Formatters.getStr(currentOrder, 'association.company.name'),
        PAGE_1_OF_2: 'Page 1 of 2',
        PAGE_2_OF_2: 'Page 2 of 2',
    };

    let textContent = _.get(bidLetterTextContents, 'contents', {});

    const processTextForPreliminaryStudy = (text: string) => {
        if (!text || !currentOrder.isPreliminaryStudy) {
            return text;
        }
        
        return text.replace(/reserve study/gi, 'Preliminary Study');
    };

    const BuildContractItems = (items: Array<any>, keyPrefix: string) => (
        _.map(items, (o, i) => {
            const originalText = Formatters.getStr(o, 'text');
            const processedText = processTextForPreliminaryStudy(originalText);
            
            return (
                <BidLetterReportComponents.BidLetterContractItem
                    key={`${keyPrefix}-${i}-${Formatters.getStr(o, 'numeral')}`}
                    numeral={Formatters.getStr(o, 'numeral')}
                    indent={Formatters.getBool(o, 'indentText')}
                >
                    <div dangerouslySetInnerHTML={{__html: stringtemplate(processedText, bidLetterContractData)}}/>
                </BidLetterReportComponents.BidLetterContractItem>
            );
        })
    );

    const blcPage1Header = stringtemplate(processTextForPreliminaryStudy(Formatters.getStr(textContent, 'contractHeaderPage1')), bidLetterContractData);
    const blcPage1Article1Items = BuildContractItems(_.get(textContent, 'contractItemsArticle1Page1'), 'blc-contract-item-page-1');

    const blcPage2Header = stringtemplate(processTextForPreliminaryStudy(Formatters.getStr(textContent, 'contractHeaderPage2')), bidLetterContractData);
    const blcPage2Article1Items = BuildContractItems(_.get(textContent, 'contractItemsArticle1Page2', []), 'blc-contract-item-page-2-top');

    const blcPage2Article2Header = stringtemplate(processTextForPreliminaryStudy(Formatters.getStr(textContent, 'contractHeaderArticle2')), bidLetterContractData);
    const blcPage2Article2Items = BuildContractItems(_.get(textContent, 'contractItemsArticle2Page2', []), 'blc-contract-item-page-2-middle');

    const blcPage2Article3Header = stringtemplate(processTextForPreliminaryStudy(Formatters.getStr(textContent, 'contractHeaderArticle3')), bidLetterContractData);
    const blcPage2Article3Items = BuildContractItems(_.get(textContent, 'contractItemsArticle3Page2', []), 'blc-contract-item-page-2-article-3');

    const blcPage2Article4Header = stringtemplate(processTextForPreliminaryStudy(Formatters.getStr(textContent, 'contractHeaderArticle4')), bidLetterContractData);
    const blcPage2Article4Items = BuildContractItems(_.get(textContent, 'contractItemsArticle4Page2', []), 'blc-contract-item-page-2-article-4');

    const blcPage2SignatureArea = stringtemplate(processTextForPreliminaryStudy(Formatters.getStr(textContent, 'contractSignaturesArea')), bidLetterContractData);

    return (
        <div>
            <BidLetterReportComponents.ReportPage className="pdf-page-order-bid-contract-page" reportData={reportData}>

                <div dangerouslySetInnerHTML={{__html: blcPage1Header }} />

                <div className="pdf-order-bid-contract-items">
                    {blcPage1Article1Items}
                </div>

                <BidLetterReportComponents.BidLetterFooter
                    pageNumText={bidLetterContractData.PAGE_1_OF_2}
                    associationName={bidLetterContractData.ASSOCIATION_NAME}
                />
            </BidLetterReportComponents.ReportPage>

            <BidLetterReportComponents.ReportPage className="pdf-page-order-bid-contract-page" reportData={reportData}>
                <div dangerouslySetInnerHTML={{__html: blcPage2Header }} />

                <div className="pdf-order-bid-contract-items">
                    {blcPage2Article1Items}
                </div>

                <div dangerouslySetInnerHTML={{__html: blcPage2Article2Header }} />

                <div className="pdf-order-bid-contract-items">
                    {blcPage2Article2Items}
                </div>

                <div dangerouslySetInnerHTML={{__html: blcPage2Article3Header }} />

                <div className="pdf-order-bid-contract-items">
                    {blcPage2Article3Items}
                </div>

                <div dangerouslySetInnerHTML={{__html: blcPage2Article4Header }} />

                <div className="pdf-order-bid-contract-items">
                   {blcPage2Article4Items}
                </div>

                <div dangerouslySetInnerHTML={{__html: blcPage2SignatureArea }} />

                <BidLetterReportComponents.BidLetterFooter
                    pageNumText={bidLetterContractData.PAGE_2_OF_2}
                    associationName={bidLetterContractData.ASSOCIATION_NAME}
                />
            </BidLetterReportComponents.ReportPage>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/order/bid-letter/pages/report-page-contract.tsx